import { FIELD_BASE_CLASS, fieldBorderClass } from '@/components/base/shared-classes';

export interface TextInputProps {
  uiId: string;
  value: string;
  onChange: (next: string) => void;
  placeholder?: string;
  disabled?: boolean;
  readOnly?: boolean;
  invalid?: boolean;
  name?: string;
  /** 原系統該欄位的長度上限（maxlength）。沒給就不輸出這個屬性。 */
  maxLength?: number;
  /** 原生 required 屬性（批次 25 #27：index 登入頁 loginName required；
   *  FC-3 欄位比對含 required attr；雛形驗證仍走 JS，屬性只是鏡像）。 */
  required?: boolean;
}

/**
 * disabled 底色 `.form-control[disabled] { background-color:#eee }`（bootstrap.css:2589-2593）。
 *
 * 【原系統缺陷】readonly 沒有底色變化：原始 CSS 寫成 `.form-control[readonly] .form-control`
 * （bootstrap.css:2585-2588）── 那是「後代選擇器」，input 底下不可能再有 .form-control，
 * 所以這條規則實際上永遠不會命中。雛形照原樣不加 readonly 底色，只保留原生 readOnly 行為。
 */
const DISABLED_BG_CLASS = 'disabled:bg-[#eee]';

/**
 * 單行文字輸入。受控元件：value 與 onChange 一定成對。
 *
 * ponytail: 用原生 `<input>` 的 disabled／readOnly／aria-invalid，不自己管 focus 或 dirty 狀態。
 * 錯誤訊息本身由 FormMessage 呈現；欄位與訊息的 aria-describedby 關聯屬於第二層 FormGrid
 * （這一層的契約沒有 describedBy prop，硬加會讓兩層都要知道對方的 ID 規則）。
 */
export function TextInput({
  uiId,
  value,
  onChange,
  placeholder,
  disabled = false,
  readOnly = false,
  invalid = false,
  name,
  maxLength,
  required = false,
}: TextInputProps) {
  return (
    <input
      type="text"
      data-ui-id={uiId}
      name={name}
      maxLength={maxLength}
      required={required || undefined}
      className={`${FIELD_BASE_CLASS} ${fieldBorderClass(invalid)} ${DISABLED_BG_CLASS}`}
      value={value}
      placeholder={placeholder}
      disabled={disabled}
      readOnly={readOnly}
      aria-invalid={invalid}
      onChange={(event) => onChange(event.target.value)}
    />
  );
}
